import {
  DASHBOARD_FLOW_SLICE_NAME,
  LEAD_MANAGEMENT_FLOW_SLICE_NAME,
  COMPONENT_FLOW_SLICE_NAME,
  ADMIN_FLOW_SLICE_NAME,
  AI_CHAT_FLOW_SLICE_NAME,
  PRODUCT_SELECTOR_FLOW_SLICE_NAME,
  FLUTTER_BROADCAST_MODAL_SLICE_NAME,
  FEATURE_FLOW_SLICE_NAME,
} from "./sliceConstants";
import dashboardReducer from "./dashboard/dashboardSlice";
import adminReducer from "./admin/adminSlice";
import notificationReducer, {
  NOTIFICATION_SLICE_NAME,
} from "./componentSlice/notificationSlice";
import chatReducer, { CHAT_SLICE_NAME } from "./componentSlice/chat";
import componentReducer from "./componentSlice/loader";
import leadManagementSlice from "./leadManagement/leadManagementSlice";
import aiChatReducer from "./aiChat/aiChatSlice";
import productselectorSlice from "./productSelector/productSelectorSlice";
import flutterBroadcastModalReducer from "./componentSlice/flutterBroadcastModalSlice";
import featureReducer from "./feature/featureSlice";

const allReducers = {
  [DASHBOARD_FLOW_SLICE_NAME]: dashboardReducer,
  [ADMIN_FLOW_SLICE_NAME]: adminReducer,
  [COMPONENT_FLOW_SLICE_NAME]: componentReducer,
  [LEAD_MANAGEMENT_FLOW_SLICE_NAME]: leadManagementSlice,
  [NOTIFICATION_SLICE_NAME]: notificationReducer,
  [CHAT_SLICE_NAME]: chatReducer,
  [AI_CHAT_FLOW_SLICE_NAME]: aiChatReducer,
  [PRODUCT_SELECTOR_FLOW_SLICE_NAME]: productselectorSlice,
  [FLUTTER_BROADCAST_MODAL_SLICE_NAME]: flutterBroadcastModalReducer,
  [FEATURE_FLOW_SLICE_NAME]: featureReducer,
};

export default allReducers;
